"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const fontSizes = {
  "xxs": "0.75rem",
  "xs": "0.875rem",
  "sm": "1rem",
  "md": "1.25rem",
  "lg": "1.75rem",
  "xl": "2.125rem",
  "xxl": "2.625rem"
};
exports.default = fontSizes;